import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const getRegistrationRequirementName = (requirement: PayeeRequirement) =>
  requirement.name || "Registration";
